export default "__VITE_ASSET__43fRgLcp__"